<template>
  <div>
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout >
        <v-flex class="text-sm-right">
          <v-btn v-if="!userMode" @click="dialogReportByList()" color="primary" round outline :loading="downloadLoading">
            {{$t('general.reportListId')}}
            <v-icon right>cloud_download</v-icon>
          </v-btn>
          <v-btn v-if="showResult && data.length != 0" @click="downloadXls()" color="primary" round outline :loading="downloadLoading">
            {{$t('expenseDetailEmployee.download')}}
            <v-icon right>cloud_download</v-icon>
          </v-btn>
          <v-btn v-if="data.length > 0" @click="downloadUserSummary()" color="primary" round outline :loading="downloadLoading">
            {{$t('expenseDetailEmployee.downloadUserSummary')}}
            <v-icon right>cloud_download</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout style="padding-bottom: 10px;">
        <v-flex class="ml-2" xs2>
          <v-select v-model="selectedStatus" :items="status" :label="$t('general.status')" :rules="rules.required" item-text="name" item-value="id" class="fixed-height" solo>
            <template slot="selection" slot-scope="data">
              {{ data.item.id === -1 ? data.item.name : $t('expenses.' + data.item.name)}}
            </template>
            <template slot="item" slot-scope="data">
              {{ data.item.id === -1 ? data.item.name : $t('expenses.' + data.item.name)}}
            </template>
          </v-select>
        </v-flex>
        <v-flex class="ml-2" xs3>
          <v-select v-model="selectedCategory" :items="categories" :label="$t('general.categories')" :rules="rules.required" item-text="name" item-value="id" class="fixed-height" solo></v-select>
        </v-flex>
        <v-flex class="ml-2" xs3>
            <v-select v-model="selectedProject" :items="projects" :label="$t('general.projects')" :rules="rules.required" item-value="id" item-text="name" class="fixed-height" solo>
              <template slot="item" slot-scope="data">
                {{ data.item.name }} - {{ data.item.status === 1 ? $t('projects.stat.active') : $t('projects.stat.inactive')}}
              </template>
              <template v-slot:selection="{ item }">
                <div class="ellipsis-2-lines" style="-webkit-box-orient: vertical !important;" :title="item.name">
                  {{ item.name }}
                </div>
              </template>
          </v-select>
        </v-flex>
        <v-flex class="ml-2" xs2>
          <v-select v-model="selectedArea" :items="areas" :label="$t('general.areas')" :rules="rules.required" item-text="name" item-value="id" class="fixed-height" solo></v-select>
        </v-flex>
        <v-flex class="ml-2" xs2>
          <v-select v-model="selectedEmployee" :items="employeeItems" :disabled="userMode" :label="$t('expenseDetailEmployee.employee')" :rules="rules.required" item-text="name" item-value="id" class="fixed-height" solo>
            <template v-slot:selection="{ item }">
              <div class="ellipsis-2-lines" style="-webkit-box-orient: vertical !important;" :title="item.name">
                {{ item.name }}
              </div>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="text-sm-right" xs2 sm2>
            <v-menu v-model="menuP" ref="menu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="startDate" :rules="rules.required" :label="$t('employerReports.startDate')" prepend-icon="event" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker color="primary" v-model="startDate" @input="menu = false" :max="today" :locale="$t('reportsType.local')" @change="limiteRangeDay()">
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
        </v-flex>
        <v-flex class="text-sm-right" xs2 sm2>
          <v-menu ref="menu2" v-model="menuP2" :close-on-content-click="true" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="endDate" :rules="rules.required" :label="$t('employerReports.endDate')" prepend-icon="event" readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker color="primary" v-model="endDate" :min="startDate" :max="todayMax" :locale="$t('reportsType.local')" @input="menu = false" @change="dateVerify()">
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex class="text-sm-right" xs1 sm1>
            <v-btn @click="search()" :loading="loadingItems" color="primary" round>
              <v-icon>search</v-icon>
              {{$t('general.search')}}
            </v-btn>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2 sm2>
          <v-switch v-model="detail" :label="detail ? $t('expenseDetailEmployee.detail') : $t('expenseDetailEmployee.noDetail')" color="primary"></v-switch>
        </v-flex>
        <v-flex xs4 sm4>
          <v-text-field v-model="searchReport" :label="$t('general.search')" clearable append-outer-icon="search"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout v-if="loadingItems">
        <v-flex>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
          <span>{{$t('general.loadingText')}}</span>
        </v-flex>
      </v-layout>
      <v-layout class="mt-3" v-if="loadingItems === false">
        <v-flex>
          <!-- <v-layout v-for="user of data" :key="user.id">
            <v-flex>
              <v-toolbar color="bg-sidebar" flat dark class="mb-3">
                <h2 class="mb-0 font-weight-black text-center">"{{ user.name }}"</h2>
              </v-toolbar>
              <v-layout v-for="expense of user.expenses" :key="expense.id">
                <v-flex class="mb-3">
                  <h2
                    class="text-sm-left font-weight-black mb-3 py-0"
                  >{{$t('general.expense') + ' ' + expense.id}}: "{{expense.description}}" <v-chip class="ml-4" outline dark color="primary">{{getStatus(expense.status_expense.id)}}</v-chip></h2>
                  <v-data-table
                    :headers="headers"
                    :items="expense[filter]"
                    class="elevation-1"
                  >
                    <template v-slot:headers="props">
                      <tr class="bg-heavy-rain">
                        <th
                          v-for="header in props.headers"
                          :class="['column']"
                          :style="header.hidden ? 'display: none;' : ''"
                          :key="header.text"
                        >
                          <h2 class="font-weight-black primary--text mb-0">{{header.text}}</h2>
                        </th>
                      </tr>
                    </template>
                    <template v-slot:items="props">
                      <tr style="border-bottom: none;">
                        <td class="text-xs-center">{{ $t('categories.' + props.item.gst_categories.name) }}</td>
                        <td class="text-xs-center d-none">{{ props.item.description }}</td>
                        <td class="text-xs-center">{{ filter === 'gst_expenses_items' ? props.item.country_sat ? props.item.country_sat.c_Pais : '' : '' }}</td>
                        <td class="text-xs-center">{{ filter === 'gst_expenses_items' ? props.item.subtotal : props.item.sumsubtotal }}</td>
                        <td class="text-xs-center">{{ filter === 'gst_expenses_items' ? props.item.total  : props.item.sumtotal }}</td>
                        <td class="text-xs-center">{{ filter === 'gst_expenses_items' ? props.item.currency_sat ? props.item.currency_sat.c_Moneda  : '' : '' }}</td>
                        <td class="text-xs-center">{{ filter === 'gst_expenses_items' ? reduceDecimal(props.item.exchange) : ''}}</td>
                        <td class="text-xs-center">{{ filter === 'gst_expenses_items' ? calculateTotal(props.item) : ''}}</td>
                      </tr>
                      <tr v-if="filter === 'gst_expenses_items'">
                        <td colspan="7">
                          <span v-if="props.item.uuid">
                            <strong>
                              {{ $t('expenseDetailEmployee.headers[4]') }}:
                            </strong>
                            {{ props.item.uuid }}
                          </span>
                          <br>
                          <span>
                            <strong>
                              {{ $t('expenseDetailEmployee.headers[2]') }}:
                            </strong>
                            <span v-html="props.item.description"></span>
                          </span>
                        </td>
                      </tr>
                    </template>
                    <template v-slot:footer>
                      <tr>
                        <td class="text-sm-left" colspan="6">
                          <strong>{{$t('general.total')}}</strong>
                        </td>
                        <td class="text-center">
                          <strong>{{totalItems(expense.gst_expenses_items)}}</strong>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex class="text-sm-left">
                  <strong>
                    <h2>Total</h2>
                  </strong>
                </v-flex>
                <v-flex class="text-sm-right">
                  <strong>
                    <h2>{{totalExpenses(user.expenses)}}</h2>
                  </strong>
                </v-flex>
              </v-layout>
              <hr class="mb-5 mt-5" />
            </v-flex>
          </v-layout> -->
          <v-data-table
            :search="searchReport"
            :headers="headers"
            :items="detailedData"
            :loading="loadingItems"
            class="elevation-1"
            :no-data-text="$t('general.noDataText')"
            :rows-per-page-items="[10,15,25]"
            :pagination.sync="pagination"
          >
          <template v-slot:no-data v-if="detailedData.length > 0">
            <center class="subtitle font-weight-light">{{$t('general.noDataText')}}</center>
          </template>
            <template v-slot:headers="props">
              <tr class="bg-heavy-rain">
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :style="header.hidden ? 'display: none;' : ''"
                  :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSort(header)"
                  >
                  <h2 class="font-weight-black primary--text mb-0">
                    <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                    {{ header.text }}
                  </h2>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr style="border-bottom: none; border-top: 1px solid; border-top-color: rgba(0, 0, 0, 0.12) !important;">
                <td class="text-xs-center">{{ props.item.item.categorie }}</td>
                <td class="text-xs-center d-none">{{ filter === 'gst_expenses_items' ? props.item.item.description : '' }}</td>
                <td class="text-xs-center" v-if="detail">{{ filter === 'gst_expenses_items' ? props.item.item.country : '' }}</td>
                <td class="text-xs-center" v-if="detail">{{ filter === 'gst_expenses_items' ? props.item.item.currency : '' }}</td>
                <td class="text-xs-center" v-if="detail"><span v-if="filter === 'gst_expenses_items'">{{ props.item.item.exchange | formatCurrency }}</span></td>
                <td class="text-xs-center">{{ props.item.item.subtotal | formatCurrency }}</td>
                <td class="text-xs-center">{{ props.item.item.total | formatCurrency }}</td>
                <td class="text-xs-center" v-if="detail">
                  <span v-if="filter === 'gst_expenses_items'">
                    {{ (+props.item.item.grand_total) + (props.item.item.tip && props.item.item.tip.amount ? +parseFloat(props.item.item.tip.amount) : +0) | formatCurrency}}
                  </span>
                </td>
                <td class="text-xs-center">{{ props.item.user.name }}</td>
                <td class="text-xs-center">{{ getStatus(props.item.expense.status_expense) }}</td>
              </tr>
              <tr v-if="filter === 'gst_expenses_items'">
                <td colspan="5">
                  <span v-if="props.item.item.UUID">
                    <strong>
                      {{ $t('expenseDetailEmployee.headers.uuid') }}:
                    </strong>
                    {{ props.item.item.UUID }}
                    <br>
                  </span>
                  <span>
                    <strong>
                      {{ $t('expenseDetailEmployee.headers.description') }}:
                    </strong>
                    <span v-html="props.item.item.description_item"></span>
                    <br>
                  </span>
                  <span>
                    <strong>
                      {{ $t('expenses.name') }}:
                    </strong>
                    <span v-html="props.item.expense.description"></span>
                  </span>
                </td>
                <td colspan="2">
                  <span v-if="props.item.item.tip && props.item.item.tip.amount && props.item.item.tip.amount > 0">
                    <strong>
                      {{ $t('expenses.tip') }}:
                    </strong>
                    {{ props.item.item.tip.amount | formatCurrency }}
                    <br>
                  </span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-dialog
        v-model="downloadZipDialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{$t('general.downloadExpensesFiles')}}</h2>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form
              ref="valDownload"
              lazy-validation
              >
              <v-layout wrap>
                <v-flex xs12>
                  <v-select
                    :items="zipsAvailables"
                    item-value="month"
                    v-model="selectedZip"
                    :label="$t('general.availableFiles')"
                    return-object
                    :rules="rules.required"
                    required
                  >
                    <template slot="selection" slot-scope="data">
                      ({{startDate.substr(0, 4) + '-' + data.item.month}}) {{$t('general.expensesFiles')}}
                    </template>
                    <template slot="item" slot-scope="data">
                      ({{startDate.substr(0, 4) + '-' + data.item.month}}) {{$t('general.expensesFiles')}}
                    </template>
                  </v-select>
                </v-flex>
              </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              round
              @click="closeDownloadDialog"
            >{{$t('general.close')}}</v-btn>
            <v-btn
              color="primary"
              depressed
              round
              @click="downloadFiles()"
              :loading="loading"
              :disabled="loading"
            >{{$t('general.download')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="dialogDownloadReportByList" max-width="600px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">{{$t('general.reportListId')}}</h2>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-form v-model="valid" lazy-validation ref="form">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-combobox v-model="expensesIds" @paste.prevent="handlePaste" @keyup.enter.prevent="handleEnter()" :label="$t('general.addExpenseIdLayout')" :rules="rules.required" ref="combo" chips multiple required>
                      <template v-slot:selection="data">
                        <v-chip :selected="data.selected" @input="remove(data.item)" close>
                          <strong>{{ data.item }}</strong>&nbsp;
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="closeDialogReportByList" color="primary darken-1" round flat>
              {{$t('general.close')}}
            </v-btn>
            <v-btn @click="downloadReportByList" :loading="downloadLoading" :disabled="!expensesIds.length > 0" color="primary" round depressed>
              {{$t('general.submit')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'expenseDetailEmployeeComponent',
  props: {
    // Modo "panel de usuario": el reporte se limita al empleado logueado y se
    // ocultan las acciones que sólo tienen sentido para administradores.
    userMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchReport: '',
      url: '',
      title: this.userMode ? this.$t('expenseDetailEmployee.myDetailReport') : this.$t('expenseDetailEmployee.nameDetailEmployees'),
      link: '',
      companyId: null,
      filter: 'gst_expenses_items',
      today: new Date().toISOString().substr(0, 10),
      todayMax: new Date().toISOString().substr(0, 10),
      showAlert: false,
      switch1: false,
      detail: true,
      switchAllEmployees: true,
      switchAllCategories: true,
      switchAllStatus: true,
      switchAllDates: false,
      switchAllAreas: true,
      switchAllProjects: true,
      downloadZipDialog: false,
      dialogDownloadReportByList: false,
      expensesIds: [],
      valid: true,
      dialog: false,
      loading: false,
      loadingItems: true,
      selectedCategory: null,
      selectedStatus: null,
      selectedArea: null,
      selectedProject: null,
      selectedEmployee: null,
      pagination: {
        sortBy: '',
        descending: true,
        page: 1,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      },
      userLogged: {},
      showResult: false,
      startDate: new Date().toISOString().substr(0, 8) + '01',
      endDate: new Date().toISOString().substr(0, 10),
      filterSelected: 'date',
      showDateFilter: false,
      menu: false,
      menu2: false,
      menuP: false,
      menuP2: false,
      selectItems: [],
      status: [],
      categories: [],
      areas: [],
      projects: [],
      employees: [],
      item_text: '',
      data: [],
      detailedData: [],
      expensesItems: null,
      selectedZip: null,
      valDownload: true,
      downloadLoading: false,
      settings: [],
      shouldGetReport: false,
      loadingDownload: false
    }
  },
  created () {
    this.onGetSettings({context: this})
    this.getLogged()
  },
  watch: {
    '$store.state.userLogged' () {
      this.getLogged()
    },
    settings (newValue) {
      if (newValue.length > 0) {
        if (this.shouldGetReport) {
          this.getReport()
          this.shouldGetReport = false
        }
      }
    },
    status() {
      if (this.status !== undefined && this.status.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allStatus') }
        this.selectedStatus = -1
        this.status.unshift(objDefault)
      }
    },
    projects () {
      if (this.projects !== undefined && this.projects.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allProjects') }
        this.selectedProject = -1
        this.projects.unshift(objDefault)
      }
    },
    areas () {
      if (this.areas !== undefined && this.areas.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allAreas') }
        this.selectedArea = -1
        this.areas.unshift(objDefault)
      }
    },
    categories () {
      if (this.categories !== undefined && this.categories.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allCategories') }
        this.selectedCategory = -1
        this.categories.unshift(objDefault)
      }
    },
    employees () {
      if (this.userMode) {
        this.selectedEmployee = this.loggedUserId
        return
      }
      if (this.employees !== undefined && this.employees.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allEmployees') }
        this.selectedEmployee = -1
        this.employees.unshift(objDefault)
      }
    }
  },
  methods: {
    dialogReportByList() {
      this.dialogDownloadReportByList = true
    },
    closeDialogReportByList () {
      this.dialogDownloadReportByList = false
      this.expensesIds = []
    },
    remove (item) {
      if (this.expensesIds.length > 0) {
        let expensesIds = this.expensesIds
        expensesIds.splice(expensesIds.indexOf(item), 1)
        this.expensesIds = [...expensesIds]
      }
    },
    handlePaste (event) {
      const pastedText = event.clipboardData.getData('text')
      const values = pastedText.split(/[\s,]+/).map(v => v.trim()).filter(v => v.length)
      this.validateIdExpensesLayout(values)
    },
    handleEnter () {
      const lastItem = this.expensesIds[this.expensesIds.length - 1]
      this.expensesIds.pop()
      const values = lastItem.split(/[\s,]+/).map(v => v.trim()).filter(v => v.length)
      this.validateIdExpensesLayout(values)
    },
    validateIdExpensesLayout (values) {
      const validCodes = []
      const invalidCodes = []

      values.forEach(code => {
        if (/^\d+$/.test(code)) { validCodes.push(code) } else { invalidCodes.push(code) }
      })

      this.expensesIds = [...new Set([...this.expensesIds, ...validCodes])]

      if (invalidCodes.length > 0) this.showNotification(this.$t('general.invalidCodesMessage', { codes: invalidCodes.join(', ') }), 'error', -1)

      this.$nextTick(() => { this.$refs.combo.searchValue = '' })
    },
    downloadReportByList () {
      this.downloadLoading = true
      this.$emit('downloadReportByList', {
        context: this,
        item: {
          companyId: this.companyId,
          listId: this.expensesIds
        }
      })
    },
    waitForSettingsAndGetReport () {
      if (this.settings.length > 0) {
        this.getReport()
      } else {
        this.shouldGetReport = true
      }
    },
    onGetSettings (event) {
      this.$store.dispatch('settings/setting_get', { event })
    },
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
        // Se fija antes de la primera búsqueda automática (ver onGetCompanyEmployees).
        if (this.userMode) this.selectedEmployee = this.userLogged.id
        this.get()
        this.getEmployees()
      }
    },
    openDialog () {
      if (this.status.length === 0) this.$emit('getStatus', {context: this})
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    save () {
      this.dialog = false
    },
    saveDate () {
      return this.date
    },
    search () {
      this.loadingDownload = true
      this.loadingItems = true
      this.loading = true
      this.data = []
      this.detailedData = []
      this.url = `${this.userLogged.company[0].id}?type=json&details=${this.detail}`
      this.url += `&startDate=${this.startDate}&endDate=${this.endDate}`

      this.filter = this.detail ? 'gst_expenses_items' : 'items_group_category'
      if (!this.userMode) {
        this.title = this.detail ? this.$t('expenseDetailEmployee.nameDetailEmployee') : this.$t('expenseDetailEmployee.nameEmployee')
      }

      if (this.userMode) {
        this.url += `&userId=${this.loggedUserId}`
      } else if (this.selectedEmployee !== null && this.selectedEmployee !== -1) {
        this.url += `&userId=${this.selectedEmployee}`
      }

      if (this.selectedCategory !== null && this.selectedCategory !== -1) {
        this.url += `&categoryId=${this.selectedCategory}`
      }

      if (this.selectedStatus !== null && this.selectedStatus !== -1) {
        this.url += `&status=${this.selectedStatus}`
      }

      if (this.selectedArea !== null && this.selectedArea !== -1) {
        this.url += `&areaId=${this.selectedArea}`
      }

      if (this.selectedProject !== null && this.selectedProject !== -1) {
        this.url += `&projectId=${this.selectedProject}`
      }

      this.waitForSettingsAndGetReport()
    },
    get () {
      this.$emit('get', {company_id: this.userLogged.company[0].id, context: this})
    },
    getEmployees () {
      this.companyId = this.userLogged.company[0].id
      this.getAreasCompany()
      this.$emit('getEmployees', {
        context: this,
        item: {
          companyId: this.companyId
        }
      })
    },
    getAreasCompany () {
      this.$emit('getAreasCompany', {
        context: this,
        item: {
          companyId: this.companyId
        }
      })
    },
    getReport () {
      this.$emit('getReport', {
        context: this,
        item: {
          companyId: this.companyId,
          url: this.url,
          isInternational: this.companyInternational
        }
      })
    },
    downloadReport () {
      this.downloadLoading = true
      var downloadUrl = this.url.replace('json', 'download')
      this.$emit('downloadReport', {
        context: this,
        item: {
          companyId: this.companyId,
          url: downloadUrl,
          isInternational: this.companyInternational
        }
      })
    },
    downloadFiles () {
      if (this.$refs.valDownload.validate()) {
        this.$emit('downloadFiles', {
          context: this,
          expensesItems: this.selectedZip,
          date: this.startDate.substr(0, 4)
        })
        this.loading = true
      }
    },
    totalItems (items) {
      var total = 0
      items.forEach(item => {
        total += this.calculateTotal(item)
      })
      return total
    },
    calculateTotal (expenseItem) {
      var total = expenseItem.total * parseFloat(expenseItem.exchange)
      return total
    },
    totalExpenses (expenses) {
      var total = 0
      expenses.forEach(exp => {
        exp['gst_expenses_items'].forEach(item => {
          total += this.calculateTotal(item)
        })
      })
      return total
    },
    getStatus (stat) {
      // var name
      // this.status.forEach(st => {
      //   if (st.name === stat) {
      //     name = st.name
      //   }
      // })
      return this.$t('expenses.' + stat)
    },
    dateVerify () {
      if (
        new Date(this.startDate).getTime() > new Date(this.endDate).getTime()
      ) {
        this.showAlert = true
        this.startDate = null
        this.endDate = null
        setTimeout(() => {
          this.showAlert = false
        }, 4000)
      }
    },
    reduceDecimal (val) {
      var num = parseFloat(val)
      return num.toFixed(2)
    },
    downloadXls () {
      this.downloadReport()
    },
    downloadUserSummary () {
      this.downloadLoading = true
      var downloadUrl = this.url.replace('json', 'download')
      this.$emit('downloadUserSummary', {
        context: this,
        item: {
          companyId: this.companyId,
          url: downloadUrl
        }
      })
    },
    changeSort (header) {
      if (header.sortable) {
        if (this.pagination.sortBy === header.value) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.descending = false
        }
        this.pagination.sortBy = header.value
      } else {
        this.pagination.sortBy = ''
      }
    },
    processDetailedData () {
      this.loadingItems = true
      this.detailedData = []
      this.data.forEach(expenses => {
        expenses.expense.forEach(exp => {
          exp.gstExpensesItems.forEach(item => {
            let userDetail = {
              id: expenses.user_id,
              name: expenses.name_user
            }
            let expenseDetail = {
              id: exp.expense_id,
              description: exp.description_expense,
              status_expense: exp.status
            }
            item.grand_total = item.total * parseFloat(item.exchange)
            let detail = { user: userDetail, expense: expenseDetail, item: item }
            this.detailedData.push(detail)
          })
        })
      })
    },
    closeDownloadDialog () {
      this.downloadZipDialog = false
      this.selectedZip = null
    },
    limiteRangeDay () {
      if (this.startDate) {
        const startDate = new Date(this.startDate)
        const maxDate = new Date(startDate)
        maxDate.setDate(startDate.getDate() + 30)
        this.endDate = maxDate > new Date(this.today) ? this.today : maxDate.toISOString().substr(0, 10)
        this.todayMax = maxDate > new Date(this.today) ? this.today : maxDate.toISOString().substr(0, 10)
      }
    }
  },
  computed: {
    loggedUserId () {
      return this.$store.state.userLogged ? this.$store.state.userLogged.id : null
    },
    // En modo usuario el select sólo ofrece al empleado logueado.
    employeeItems () {
      if (!this.userMode) return this.employees
      return this.employees.filter(employee => employee.id === this.loggedUserId)
    },
    companyInternational () {
      if (this.$store.state.userLogged.company === undefined) return false

      if (this.settings.length > 0) {
        let country = this.settings.find(x => x.setting_type.name === 'st.country' && x.company_id === this.$store.state.userLogged.company[0].id)
        return country.value.c_Pais !== 'MEX'
      }

      return false
    },
    heading () {
      return this.title
    },
    subheading () {
      return ''
    },
    icon () {
      return 'far fa-file-alt fa-fw icon-color'
    },
    headers () {
      let headers = [
        {
          text: this.$t('expenseDetailEmployee.headers.category'),
          value: 'item.categorie',
          align: 'center',
          sortable: true,
          class: 'font-weight-black white--text column primary'
        },
        {
          text: this.$t('expenseDetailEmployee.headers.uuid'),
          value: 'item.uuid',
          align: 'center',
          class: 'font-weight-black white--text column primary',
          hidden: true
        },
        {
          text: this.$t('expenseDetailEmployee.headers.description'),
          value: 'item.description',
          align: 'center',
          class: 'font-weight-black white--text column primary',
          hidden: true
        },
        {
          text: this.$t('expenseDetailEmployee.headers.subtotal'),
          value: 'item.subtotal',
          align: 'center',
          sortable: true,
          class: 'font-weight-black white--text column primary'
        },
        {
          text: this.$t('expenseDetailEmployee.headers.total'),
          value: 'item.total',
          align: 'center',
          sortable: true,
          class: 'font-weight-black white--text column primary'
        },
        {
          text: this.$t('expenseDetailEmployee.headers.grandTotal'),
          value: 'item.grand_total',
          align: 'center',
          sortable: true,
          class: 'font-weight-black white--text column primary'
        },
        {
          text: this.$t('expenseDetailEmployee.headers.employee'),
          value: 'user.name',
          align: 'center',
          sortable: true,
          class: 'font-weight-black white--text column primary'
        },
        {
          text: this.$t('expenseDetailEmployee.headers.status'),
          value: 'expense.status_expense.id',
          align: 'center',
          sortable: true,
          class: 'font-weight-black white--text column primary'
        }
      ]
      if (this.detail) {
        headers.splice(1, 0, {
          text: this.$t('expenseDetailEmployee.headers.country'),
          value: 'item.country_sat.c_Pais',
          align: 'center',
          sortable: true,
          class: 'font-weight-black white--text column primary'
        })
        headers.splice(4, 0, {
          text: this.$t('expenseDetailEmployee.headers.currency'),
          value: 'item.currency_sat.c_Moneda',
          align: 'center',
          sortable: true,
          class: 'font-weight-black white--text column primary'
        },
        {
          text: this.$t('expenseDetailEmployee.headers.exchange'),
          value: 'item.exchange',
          align: 'center',
          sortable: true,
          class: 'font-weight-black white--text column primary'
        }
        // {
        //   text: this.$t('expenseDetailEmployee.headers.grandTotal'),
        //   value: 'item.grand_total',
        //   align: 'center',
        //   sortable: true,
        //   class: 'font-weight-black white--text column primary'
        // }
        )
      }
      return headers
    },
    zipsAvailables () {
      if (this.expensesItems && this.expensesItems.length > 0) {
        if (this.switchAllDates) {
          return this.expensesItems
        } else {
          let startMonth = this.startDate.substr(5, 2)
          let endMonth = this.endDate.substr(5, 2)
          let filtro = this.expensesItems.filter(item => item.month >= startMonth && item.month <= endMonth)
          return filtro
        }
      }
    },
    rules () {
      return this.$validationRules()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/expenseDetailEmployee.component.vue